import { useMemo } from 'react';

import { useCareStateDomain } from '@/entities/care-state-domain';
import {
  selectEnrichedActiveActions,
  type EnrichedActiveProposedAction,
} from '@/entities/proposed-actions';

export type EnrichedProposedAction = EnrichedActiveProposedAction;

export function useProposedActionsPlan() {
  // Proposed actions are intentionally NOT scope-filtered: the plan view shows
  // every active action for the patient regardless of which problem/request
  // scope is currently selected in the care state scope tree.
  const { careState } = useCareStateDomain();
  const allActions = useMemo(() => careState?.proposed_actions ?? [], [careState]);
  const enriched = useMemo<EnrichedProposedAction[]>(
    () => selectEnrichedActiveActions(allActions),
    [allActions]
  );

  return {
    actions: enriched,
    isEmpty: enriched.length === 0,
    isLoading: careState === null,
  };
}
